import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import TvecLayout from '../../components/TvecLayout';
import TvecBreadcrumb from '../../components/TvecBreadcrumb';
import { PREMISES_ITEMS } from '../../utils/tvecPremises';

export default function TvecPremises() {
  const [search, setSearch] = useState('');
  const items = useMemo(() => {
    const q = search.trim().toLowerCase();
    return q ? PREMISES_ITEMS.filter((i) => i.title.toLowerCase().includes(q)) : PREMISES_ITEMS;
  }, [search]);

  return (
    <TvecLayout title="Premises and Resources">
      <div className="w-full">
        <TvecBreadcrumb items={[{ label: 'TVEC', href: '/tvec/dashboard' }, { label: 'Premises and Resources' }]} />

        <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 className="text-lg font-semibold text-slate-900">Premises and Resources</h2>
            <p className="text-sm text-slate-500">Choose an area to open its page.</p>
          </div>
          <input
            type="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search…"
            aria-label="Search premises and resources"
            className="w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-sm placeholder:text-slate-400 focus:border-sky-400 focus:outline-none focus:ring-2 focus:ring-sky-100 sm:w-72"
          />
        </div>

        {items.length === 0 ? (
          <p className="rounded-2xl border border-dashed border-slate-300 bg-white px-4 py-12 text-center text-sm text-slate-500">Nothing matches your search.</p>
        ) : (
          <ul className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
            {items.map((item) => (
              <li key={item.slug}>
                <Link
                  to={item.path}
                  className="group flex h-full items-center gap-3 rounded-2xl border border-slate-200 bg-white p-4 no-underline shadow-sm transition hover:border-sky-300 hover:shadow-md"
                >
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sky-50 text-sm font-bold text-sky-700 group-hover:bg-sky-600 group-hover:text-white">
                    {item.number}
                  </span>
                  <span className="min-w-0 flex-1 text-sm font-semibold text-slate-800">{item.title}</span>
                  <span aria-hidden="true" className="text-slate-300 group-hover:text-sky-600">›</span>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </TvecLayout>
  );
}
